import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["data", "index", "expandableContent", "isExpanded", "isStriped", "expandableContentHasBackgroundColor", "expandableRowHasTopBorder", "isSorted", "spacing", "columns"];
import React from 'react';
import { ExpanderContent } from "../../expander";
import { View } from "../../layout";
import { TdElement as Td, TrElement as Tr } from "../html";
import { getVerticalSpacingForCell } from "./utils";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ExpandableRowsByRows = function ExpandableRowsByRows(_ref) {
  var data = _ref.data,
      index = _ref.index,
      getRowExpandableContent = _ref.expandableContent,
      isExpanded = _ref.isExpanded,
      isStriped = _ref.isStriped,
      expandableContentHasBackgroundColor = _ref.expandableContentHasBackgroundColor,
      expandableRowHasTopBorder = _ref.expandableRowHasTopBorder,
      isSorted = _ref.isSorted,
      spacing = _ref.spacing,
      columns = _ref.columns,
      trProps = _objectWithoutProperties(_ref, _excluded);

  return !!getRowExpandableContent ? ___EmotionJSX(React.Fragment, null, getRowExpandableContent({
    data: data,
    index: index
  }).map(function (ExpandableRowContent, expRowIndex) {
    return ___EmotionJSX(Tr, _extends({}, trProps, {
      key: expRowIndex,
      isExpandableContent: true,
      hasBackgroundColor: isStriped || expandableContentHasBackgroundColor,
      hasTopBorderWhenExpanded: expandableRowHasTopBorder && isExpanded
    }), ___EmotionJSX(Td, {
      colSpan: columns.length + 1
    }, ___EmotionJSX(ExpanderContent, {
      isExpanded: isExpanded,
      shouldAnimateImmediately: isSorted,
      topSpacing: expandableRowHasTopBorder ? getVerticalSpacingForCell(spacing) : undefined
    }, ___EmotionJSX(View, {
      padding: {
        bottom: getVerticalSpacingForCell(spacing)
      }
    }, ExpandableRowContent))));
  })) : null;
};